<div class="pcoded"
     [class.mechanic-layout]="isMechanicUser"
     [attr.nav-type]="navType"
     [attr.theme-layout]="themeLayout"
     [attr.layout-type]="layoutType"
     [attr.vertical-placement]="verticalPlacement"
     [attr.vertical-layout]="verticalLayout"
     [attr.pcoded-device-type]="deviceType"
     [attr.vertical-nav-type]="verticalNavType"
     [attr.vertical-effect]="verticalEffect"
     [attr.vnavigation-view]="vNavigationView"
     (window:resize)="onResize($event)">
  <div class="pcoded-overlay-box"></div>
  <div class="pcoded-container navbar-wrapper">
    <nav class="navbar header-navbar pcoded-header" [attr.pcoded-header-position]="pcodedHeaderPosition" [attr.header-theme]="headerTheme">
      <div class="navbar-wrapper">
        <div class="navbar-logo" [attr.logo-theme]="logoTheme" (click)="returnToHome()" style="cursor: pointer;">
          <span class="workroo-brand-title">WORKROO</span>
        </div>

        <div class="navbar-container">
          <div class="header-content-flex">
            <div class="header-left d-flex align-items-center">
              <div class="sidebar_toggle d-lg-none mr-3" *ngIf="!isMechanicUser">
                <a href="javascript:;" id="mobile-collapse" class="topbar-menu-toggle" (click)="toggleOpened()" aria-label="Open menu"><i class="ti-menu"></i></a>
              </div>
              <h2 class="header-main-title" *ngIf="getPageTitle()">{{ getPageTitle() }}</h2>
            </div>

            <div class="header-right d-flex align-items-center">
              <div class="header-dashboard-search" *ngIf="showHeaderSearch">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <input
                  type="text"
                  [value]="isDashboardRoute() ? dashboardSearchQuery : topBarSearchQuery"
                  placeholder="Search jobs, customers, vehicles..."
                  aria-label="Search jobs, customers, vehicles..."
                  (input)="onTopBarSearchInput($any($event.target).value)"
                  (keyup.enter)="onTopBarSearchSubmit()" />
              </div>
              <button class="header-new-job-btn" *ngIf="showHeaderCreateJob" type="button" (click)="onTopBarNewJob()">
                <i class="ti-plus" aria-hidden="true"></i>
                <span>New Job</span>
              </button>
              <label class="header-theme-toggle" *ngIf="showHeaderDarkTheme">
                <ui-switch class="header-theme-switch"
                           [checked]="isDarkTheme"
                           (change)="onChangeTheme($event)"
                           color="#3A63FF"
                           switchColor="#fff"
                           size="small"></ui-switch>
                <span>Dark Theme</span>
              </label>
              <div class="header-profile" *ngIf="showHeaderProfile">
                <button type="button" class="header-profile-btn"
                        [class.is-open]="isHeaderProfileOpen"
                        (click)="toggleHeaderProfileMenu($event)"
                        aria-haspopup="menu"
                        [attr.aria-expanded]="isHeaderProfileOpen"
                        aria-label="Open profile menu">
                  <span class="header-profile-avatar">{{ getUserInitials() }}</span>
                  <span class="header-profile-meta">
                    <span class="header-profile-name">{{ getUserDisplayName() }}</span>
                    <span class="header-profile-role">{{ getUserRole() }}</span>
                  </span>
                  <i class="ti-angle-down" aria-hidden="true"></i>
                </button>
                <div class="header-profile-menu" *ngIf="isHeaderProfileOpen" role="menu" (click)="$event.stopPropagation()">
                  <a class="header-profile-menu-item" role="menuitem" [routerLink]="['/user/profile']">
                    <i class="ti-user" aria-hidden="true"></i>
                    <span>Profile</span>
                  </a>
                  <button type="button" class="header-profile-menu-item" role="menuitem" (click)="logout($event)">
                    <i class="ti-layout-sidebar-left" aria-hidden="true"></i>
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!-- rightbar chat start -->
    <div [@slideInOut]="verticalPlacement === 'right' ? chatToggleInverse : chatToggle" id="sidebar" class="users p-chat-user">
      <div class="had-container">
        <div class="card card_main p-fixed users-main">
          <div class="user-box">
            <div class="card-body">
              <div class="right-icon-control">
                <input class="form-control search-text" placeholder="Search Friend" id="search-friends" #searchFriends (keyup)="searchFriendList($event)">
                <div class="form-icon">
                  <i class="icofont icofont-search"></i>
                </div>
              </div>

            </div>
            <div slimScroll [options]="chatOpts" class="main-friend-list scroll-window">
              <div (click)="toggleChatInner()" class="media userlist-box" data-id="1" placement="left" ngbTooltip="Josephin Doe">
                <a class="media-left" href="javascript:;">
                  <img class="media-object " src="assets/images/avatar-2.jpg" alt="Generic placeholder image">
                  <div class="live-status bg-success"></div>
                </a>
                <div class="media-body">
                  <div class="f-13 chat-header">Josephin Doe</div>
                </div>
              </div>
              <div (click)="toggleChatInner()" class="media userlist-box" data-id="2" data-status="online" data-username="Lary Doe" placement="left" ngbTooltip="Lary Doe">
                <a class="media-left" href="javascript:;">
                  <img class="media-object " src="assets/images/avatar-3.jpg" alt="Generic placeholder image">
                  <div class="live-status bg-success"></div>
                </a>
                <div class="media-body">
                  <div class="f-13 chat-header">Lary Doe</div>
                </div>
              </div>
              <div (click)="toggleChatInner()" class="media userlist-box" data-id="3" data-status="online" data-username="Alice" placement="left" ngbTooltip="Alice">
                <a class="media-left" href="javascript:;">
                  <img class="media-object " src="assets/images/avatar-5.jpg" alt="Generic placeholder image">
                  <div class="live-status bg-success"></div>
                </a>
                <div class="media-body">
                  <div class="f-13 chat-header">Alice</div>
                </div>
              </div>
              <div (click)="toggleChatInner()" class="media userlist-box" data-id="4" data-status="offline" data-username="Alia" placement="left" ngbTooltip="Alia">
                <a class="media-left" href="javascript:;">
                  <img class="media-object " src="assets/images/avatar-3.jpg" alt="Generic placeholder image">
                  <div class="live-status bg-danger"></div>
                </a>
                <div class="media-body">
                  <div class="f-13 chat-header">Alia</div>
                </div>
              </div>
              <div (click)="toggleChatInner()" class="media userlist-box" data-id="5" data-status="online" data-username="Suzen" placement="left" ngbTooltip="Suzen">
                <a class="media-left" href="javascript:;">
                  <img class="media-object " src="assets/images/avatar-5.jpg" alt="Generic placeholder image">
                  <div class="live-status bg-success"></div>
                </a>
                <div class="media-body">
                  <div class="f-13 chat-header">Suzen</div>
                </div>
              </div>
              <div (click)="toggleChatInner()" class="media userlist-box" data-id="6" data-status="offline" data-username="Michael Scofield" placement="left" ngbTooltip="Michael Scofield">
                <a class="media-left" href="javascript:;">
                  <img class="media-object " src="assets/images/avatar-2.jpg" alt="Generic placeholder image">
                  <div class="live-status bg-danger"></div>
                </a>
                <div class="media-body">
                  <div class="f-13 chat-header">Michael Scofield</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div [@slideOnOff]="verticalPlacement === 'right' ? chatInnerToggleInverse : chatInnerToggle" class="card card_main showChat_inner">
      <div class="media chat-inner-header">
        <a class="back_chatBox" (click)="toggleChatInner()">
          <i class="icofont icofont-rounded-left"></i> Josephin Doe
        </a>
      </div>
      <div slimScroll [options]="chatOpts" class="scroll-window">
        <div class="media chat-messages">
          <a class="media-left photo-table" href="javascript:;">
            <img class="media-object  m-t-5" src="assets/images/avatar-1.jpg" alt="Generic placeholder image">
          </a>
          <div class="media-body chat-menu-content">
            <div class="">
              <p class="chat-cont">I'm just looking around. Will you tell me something about yourself?</p>
              <p class="chat-time">8:20 a.m.</p>
            </div>
          </div>
        </div>
        <div class="media chat-messages">
          <div class="media-body chat-menu-reply">
            <div class="">
              <p class="chat-cont">I'm just looking around. Will you tell me something about yourself?</p>
              <p class="chat-time">8:20 a.m.</p>
            </div>
          </div>
          <div class="media-right photo-table">
            <a href="javascript:;">
              <img class="media-object  m-t-5" src="assets/images/avatar-4.jpg" alt="Generic placeholder image">
            </a>
          </div>
        </div>
        <div class="chat-reply-box p-b-20">
          <div class="right-icon-control">
            <input type="text" class="form-control search-text" placeholder="Share Your Thoughts">
            <div class="form-icon">
              <i class="icofont icofont-paper-plane"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- right-bar inner chat end -->

    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin">
      <div class="pcoded-wrapper">
        <nav id="main_navbar" class=" pcoded-navbar" *ngIf="!isMechanicUser" (clickOutside)="onClickedOutside($event)" [exclude]="'#mobile-collapse'" [attr.pcoded-header-position]="pcodedHeaderPosition" [attr.navbar-theme]="navBarTheme" [attr.active-item-theme]="activeItemTheme" sub-item-theme="theme2" active-item-style="style0" [attr.pcoded-navbar-position]="pcodedSidebarPosition">
          <div class="sidebar_toggle"><a href="javascript:;"><i class="icon-close icons"></i></a></div>
          <div class="pcoded-inner-navbar main-menu" appAccordion>

            <!--pubudu 
            <div class="">
              <div class="main-menu-header">
                <img class="img-40 img-radius" src="assets/images/avatar-4.jpg" alt="User-Profile-Image">
                <div class="user-details">
                  <span>John Doe</span>
                  <span id="more-details" (click)="toggleOpenedSidebar()">UX Designer<i class="ti-angle-down"></i></span>
                </div>
              </div>
              <div class="main-menu-content">
                <ul>
                  <li [@mobileMenuTop]="isCollapsedSideBar" class="more-details" [ngClass]="isCollapsedSideBar">
                    <a [routerLink]="['/user/profile']"><i class="ti-user"></i>View Profile</a>
                    <a [routerLink]="['/crm-contact']"><i class="ti-settings"></i>Settings</a>
                    <a [routerLink]="['/authentication/login/page']"><i class="ti-layout-sidebar-left"></i>Logout</a>
                  </li>
                </ul>
              </div>
            </div>
          -->
            <div class="pcoded-search">
              <span class="searchbar-toggle">  </span>
              <div class="pcoded-search-box ">
                <input type="text" placeholder="Search">
                <span class="search-icon"><i class="ti-search" aria-hidden="true"></i></span>
              </div>
            </div>
            <div class="pcoded-menu-scroll">
            
            <!--pubudu this is the location set the menu of the app - original function getAll- -->
            
              <div *ngFor="let asideItems of menuItems.getMenuByUserType()" class="d-color side-nav-group">
                <div *ngIf="asideItems.label" class="side-nav-section-header pcoded-navigatio-lavel" [attr.menu-title-theme]="menuTitleTheme">{{asideItems.label}}</div>
                <ul class="pcoded-item pcoded-left-item" [attr.item-border]="itemBorder" [attr.item-border-style]="itemBorderStyle" [attr.subitem-border]="subItemBorder" *ngFor="let asideItem of asideItems.main" appAccordionLink group="{{asideItem.state}}">
                  <li [routerLinkActive]="['active']" *ngIf="asideItem.type === 'external'" appAccordionLink group="{{asideItem.state}}">
                    <a href="{{asideItem.external}}" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle>
                      <span class="figma-micon">
                        <img *ngIf="asideItem.svgIcon" [src]="asideItem.svgIcon" class="sidebar-svg-icon" alt="" />
                        <i *ngIf="!asideItem.svgIcon" class="{{ asideItem.icon }}"></i>
                      </span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="sidebar-badge">{{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                  </li>

                  <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" *ngIf="asideItem.type === 'link'" appAccordionLink group="{{asideItem.state}}">
                    <a [routerLink]="['/', asideItem.main_state, asideItem.state]" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle *ngIf="asideItem.main_state; else mainContent">
                      <span class="figma-micon">
                        <img *ngIf="asideItem.svgIcon" [src]="asideItem.svgIcon" class="sidebar-svg-icon" alt="" />
                        <i *ngIf="!asideItem.svgIcon" class="{{ asideItem.icon }}"></i>
                      </span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="sidebar-badge">{{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ng-template #mainContent>
                      <a [routerLink]="['/', asideItem.state]" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle>
                        <span class="figma-micon">
                          <img *ngIf="asideItem.svgIcon" [src]="asideItem.svgIcon" class="sidebar-svg-icon" alt="" />
                          <i *ngIf="!asideItem.svgIcon" class="{{ asideItem.icon }}"></i>
                        </span>
                        <span class="pcoded-mtext">{{ asideItem.name }}</span>
                        <span *ngFor="let asideBadge of asideItem.badge" class="sidebar-badge">{{asideBadge.value}}</span>
                        <span class="pcoded-mcaret"></span>
                      </a>
                    </ng-template>
                  </li>
                  <li [routerLinkActive]="['active']" *ngIf="asideItem.type === 'sub'" class="pcoded-hasmenu" [attr.dropdown-icon]="dropDownIcon" [attr.subitem-icon]="subItemIcon" appAccordionLink group="{{asideItem.state}}">
                    <a [routerLinkActive]="['active']" href="javascript:;" appAccordionToggle>
                      <span class="figma-micon">
                        <img *ngIf="asideItem.svgIcon" [src]="asideItem.svgIcon" class="sidebar-svg-icon" alt="" />
                        <i *ngIf="!asideItem.svgIcon" class="{{ asideItem.icon }}"></i>
                      </span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="sidebar-badge">{{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ul class="pcoded-submenu">
                      <ng-template ngFor let-asideChildren [ngForOf]="asideItem.children">
                        <li [routerLinkActive]="['active']" *ngIf="asideChildren.type !== 'sub'">
                          <a [routerLink]="['/', asideItem.state, asideChildren.state]" target="{{asideChildren.target ? '_blank' : '_self'}}">
                            <span class="figma-micon"><i class="ti-angle-right"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name }} </span>
                            <span *ngFor="let asideChildrenBadge of asideChildren.badge" class="sidebar-badge">{{asideChildrenBadge.value}}</span>
                            <span class="pcoded-mcaret"></span>
                          </a>
                        </li>

                        <li [routerLinkActive]="['active']" class="pcoded-hasmenu" [attr.dropdown-icon]="dropDownIcon" [attr.subitem-icon]="subItemIcon" *ngIf="asideChildren.type === 'sub'" appAccordionLink group="sub-toggled">
                          <a href="javascript:;" appAccordionToggle>
                            <span class="figma-micon"><i class="ti-direction-alt"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name }}</span>
                            <span *ngFor="let asideChildrenBadge of asideChildren.badge" class="sidebar-badge">{{asideChildrenBadge.value}}</span>
                            <span class="pcoded-mcaret"></span>
                          </a>
                          <ul class="pcoded-submenu">
                            <ng-template ngFor let-asideChildrenSub [ngForOf]="asideChildren.children">
                              <li [routerLinkActive]="['active']">
                                <a [routerLink]="['/', asideItem.state, asideChildren.state, asideChildrenSub.state]" target="{{asideChildrenSub.target ? '_blank' : '_self'}}">
                                  <span class="figma-micon"><i class="ti-angle-right"></i></span>
                                  <span class="pcoded-mtext">{{ asideChildrenSub.name }}</span>
                                  <span *ngFor="let asideChildrenSubBadge of asideChildrenSub.badge" class="sidebar-badge">{{asideChildrenSubBadge.value}}</span>
                                  <span class="pcoded-mcaret"></span>
                                </a>
                              </li>
                            </ng-template>
                          </ul>
                        </li>
                      </ng-template>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Figma side-nav footer card (Profile Navigation) -->
            <div class="sidebar-user-footer">
              <div class="sidebar-user-footer-profile" [routerLink]="['/user/profile']" title="User Profile">
                <div class="user-avatar-circle">
                  <span>{{ getUserInitials() }}</span>
                </div>
                <div class="user-meta-info">
                  <span class="user-meta-name" [title]="getUserDisplayName()">{{ getUserDisplayName() }}</span>
                  <span class="user-meta-role">{{ getUserRole() }}</span>
                </div>
              </div>
              <!-- Figma footer chevron opens the account menu -->
              <div class="sidebar-user-menu-wrap">
                <button type="button" class="sidebar-user-menu-btn" [class.is-open]="isUserMenuOpen"
                        (click)="toggleUserMenu($event)" title="Account" aria-label="Account menu"
                        aria-haspopup="menu" [attr.aria-expanded]="isUserMenuOpen">
                  <img src="assets/icons/sidebar/chevron-right.svg" width="24" height="24" alt="" />
                </button>
                <div class="sidebar-user-menu" *ngIf="isUserMenuOpen" role="menu" (click)="$event.stopPropagation()">
                  <div class="sidebar-user-menu-item sidebar-user-menu-theme" role="menuitem">
                    <i class="ti-shine" aria-hidden="true"></i>
                    <span>Dark Theme</span>
                    <ui-switch class="sidebar-theme-switch"
                               [checked]="isDarkTheme"
                               (change)="onChangeTheme($event)"
                               color="#3A63FF"
                               switchColor="#fff"
                               size="small">
                    </ui-switch>
                  </div>
                  <button type="button" class="sidebar-user-menu-item" role="menuitem" (click)="logout($event)">
                    <i class="ti-layout-sidebar-left" aria-hidden="true"></i>
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div class="pcoded-content">
          <div class="pcoded-inner-content">
            <div class="main-body">
              <div class="page-wrapper">
                <app-title></app-title>
                <app-breadcrumbs></app-breadcrumbs>
                <div class="page-body">
                  <router-outlet>
                    <app-spinner></app-spinner>
                  </router-outlet>
                </div>
              </div>
            </div>

            <!-- pubudu change to hide settings button *ngIf="false"-->
            <div *ngIf="false"   id="styleSelector" class="{{ configOpenRightBar }}">
              <div class="selector-toggle">
                <a href="javascript:" (click)="toggleRightbar()"></a>
              </div>
              <ul>
                <li><p class="selector-title main-title st-main-title">Guru able Customizer</p><span class="text-muted">Live customizer with tons of options</span></li>
                <li><p class="selector-title">Main layouts</p></li>
                <li>
                  <div class="theme-color">
                    <a href="javascript:" (click)="setNavBarTheme('themelight1')" navbar-theme="themelight1">
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                    <a href="javascript:" (click)="setNavBarTheme('theme1')" navbar-theme="theme1">
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                    <a href="javascript:" (click)="setLayoutType('light')" layout-type="light">
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                    <a href="javascript:" (click)="setLayoutType('dark')" layout-type="dark">
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                  </div>
                </li>
              </ul>
              <div class="style-cont">
                <div class="slimScrollDiv scroll-window" slimScroll width="100%" size="7px" color="rgb(153, 153, 153)" opacity="0.4">
                  <div class="md-tabs">
                    <ul ngbNav #nav="ngbNav" class="nav-tabs">
                      <li ngbNavItem>
  <a ngbNavLink>Layout</a>
  <ng-template ngbNavContent>
                        <ng-template ngbTabContent>
                          <div [@fadeInOutTranslate] class="m-t-15">
                            <ul>
                              <li class="theme-option">
                                <div class="checkbox-fade fade-in-pimary">
                                  <label>
                                    <input type="checkbox" value="false" id="sidebar-position" name="sidebar-position" [checked]="isSidebarChecked" (change)="setSidebarPosition()">
                                    <span class="cr"><i class="cr-icon icofont icofont-ui-check txt-success"></i></span>
                                    <span>Fixed Sidebar Position</span>
                                  </label>
                                </div>
                              </li>
                              <li class="theme-option">
                                <div class="checkbox-fade fade-in-primary">
                                  <label>
                                    <input type="checkbox" value="false" id="header-position" name="header-position" [checked]="isHeaderChecked" (change)="setHeaderPosition()">
                                    <span class="cr"><i class="cr-icon icofont icofont-ui-check txt-success"></i></span>
                                    <span>Fixed Header Position</span>
                                  </label>
                                </div>
                              </li>

                              <!--<li class="theme-option">-->
                                <!--<div class="checkbox-fade fade-in-primary">-->
                                  <!--<label>-->
                                    <!--<input type="checkbox" value="false" id="vertical-item-border" name="vertical-item-border" (change)="this.itemBorder=!itemBorder">-->
                                    <!--<span class="cr"><i class="cr-icon icofont icofont-ui-check txt-success"></i></span>-->
                                    <!--<span>Hide Item Border</span>-->
                                  <!--</label>-->
                                <!--</div>-->
                              <!--</li>-->
                              <!--<li class="theme-option">-->
                                <!--<div class="checkbox-fade fade-in-primary">-->
                                  <!--<label>-->
                                    <!--<input type="checkbox" value="false" id="vertical-subitem-border" name="vertical-item-border" (change)="this.subItemBorder=!subItemBorder">-->
                                    <!--<span class="cr"><i class="cr-icon icofont icofont-ui-check txt-success"></i></span>-->
                                    <!--<span>Hide SubItem Border</span>-->
                                  <!--</label>-->
                                <!--</div>-->
                              <!--</li>-->
                            </ul>
                          </div>
                        </ng-template>
                      </ng-template>
</li>
                      <li ngbNavItem>
  <a ngbNavLink>Sidebar</a>
  <ng-template ngbNavContent>
                        <ng-template ngbTabContent>
                          <div [@fadeInOutTranslate] class="m-t-15">
                            <ul>
                              <li class="theme-option">
                                <p class="sub-title">Menu Type</p>
                                <div class="form-radio m-b-15" id="menu-effect">
                                  <div class="radio radiofill radio-primary radio-inline">
                                    <label>
                                      <input type="radio" name="radio" value="st1" (click)="this.navType=$event.target.value">
                                      <i class="helper"></i>
                                      <span class="micon st1">
                                        <i class="ti-home"></i><b>D</b>
                                      </span>
                                    </label>
                                  </div>
                                  <div class="radio radiofill radio-success radio-inline">
                                    <label>
                                      <input type="radio" name="radio" value="st2" checked="true" (click)="this.navType=$event.target.value">
                                      <i class="helper"></i>
                                      <span class="micon st2">
                                        <i class="ti-home"></i><b>D</b>
                                      </span>
                                    </label>
                                  </div>
                                  <div class="radio radiofill radio-warning radio-inline">
                                    <label>
                                      <input type="radio" name="radio" value="st3" (click)="this.navType=$event.target.value">
                                      <i class="helper"></i>
                                      <span class="micon st3">
                                        <i class="ti-home"></i><b>D</b>
                                      </span>
                                    </label>
                                  </div>
                                  <div class="radio radiofill radio-danger radio-inline">
                                    <label>
                                      <input type="radio" name="radio" value="st4" (click)="this.navType=$event.target.value">
                                      <i class="helper"></i>
                                      <span class="micon st4">
                                        <i class="ti-home"></i><b>D</b>
                                      </span>
                                    </label>
                                  </div>
                                  <div class="radio radiofill radio-primary radio-inline">
                                    <label>
                                      <input type="radio" name="radio" value="st5" (click)="this.navType=$event.target.value">
                                      <i class="helper"></i>
                                      <span class="micon st5">
                                        <i class="ti-home"></i><b>D</b>
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title">Page Layout</p>
                                <select id="theme-layout" class="form-control minimal input-sm" (change)="this.verticalLayout=$event.target.value">
                                  <option value="wide">Wide layout</option>
                                  <option value="box">Boxed layout</option>
                                </select>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title">Navbar Placement</p>
                                <select id="vertical-navbar-placement" class="form-control minimal input-sm" (change)="this.verticalPlacement=$event.target.value">
                                  <option value="left" selected>Left</option>
                                  <option value="right">Right</option>
                                </select>
                              </li>
                            </ul>
                          </div>
                          <div [@fadeInOutTranslate] class="m-t-15">
                            <ul>
                              <li class="theme-option">
                                <p class="sub-title drp-title">SideBar Effect</p>
                                <select id="vertical-menu-effect" class="form-control minimal" (change)="this.verticalEffect=$event.target.value">
                                  <option value="shrink">shrink</option>
                                  <option value="overlay">overlay</option>
                                  <option value="push">Push</option>
                                </select>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title drp-title">Border Style</p>
                                <select id="vertical-border-style" class="form-control minimal" (change)="this.itemBorderStyle=$event.target.value">
                                  <option value="solid" selected>Style 1</option>
                                  <option value="dotted">Style 2</option>
                                  <option value="dashed">Style 3</option>
                                  <option value="none">No Border</option>
                                </select>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title drp-title">DropDown Icon</p>
                                <select id="vertical-dropdown-icon" class="form-control minimal" (change)="this.dropDownIcon=$event.target.value">
                                  <option value="style1" selected>Style 1</option>
                                  <option value="style2">style 2</option>
                                  <option value="style3">style 3</option>
                                </select>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title drp-title">Submenu Item Icon</p>
                                <select id="vertical-subitem-icon" class="form-control minimal" (change)="this.subItemIcon=$event.target.value">
                                  <option value="style1">Style 1</option>
                                  <option value="style2">style 2</option>
                                  <option value="style3">style 3</option>
                                  <option value="style4">style 4</option>
                                  <option value="style5">style 5</option>
                                  <option value="style6" selected>style 6</option>
                                </select>
                              </li>
                            </ul>
                          </div>
                        </ng-template>
                      </ng-template>
</li>
                    </ul>
<div [ngbNavOutlet]="nav"></div>
                  </div>
                  <div class="tab-content tabs">
                    <ul>
                      <li><p class="selector-title">Menu Caption Color</p></li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a href="javascript:" class="small" (click)="this.menuTitleTheme='theme1'" lheader-theme="theme1"></a>
                          <a href="javascript:" class="small" (click)="this.menuTitleTheme='theme2'" lheader-theme="theme2"></a>
                          <a href="javascript:" class="small" (click)="this.menuTitleTheme='theme3'" lheader-theme="theme3"></a>
                          <a href="javascript:" class="small" (click)="this.menuTitleTheme='theme4'" lheader-theme="theme4"></a>
                          <a href="javascript:" class="small" (click)="this.menuTitleTheme='theme5'" lheader-theme="theme5"></a>
                          <a href="javascript:" class="small" (click)="this.menuTitleTheme='theme6'" lheader-theme="theme6"></a>
                        </div>
                      </li>
                      <li><p class="selector-title">Active item Theme</p></li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a href="javascript:" (click)="this.activeItemTheme='theme1'" class="small" active-item-theme="theme1"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme2'" class="small" active-item-theme="theme2"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme3'" class="small" active-item-theme="theme3"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme4'" class="small" active-item-theme="theme4"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme5'" class="small" active-item-theme="theme5"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme6'" class="small" active-item-theme="theme6"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme7'" class="small" active-item-theme="theme7"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme8'" class="small" active-item-theme="theme8"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme9'" class="small" active-item-theme="theme9"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme10'" class="small" active-item-theme="theme10"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme11'" class="small" active-item-theme="theme11"></a>
                          <a href="javascript:" (click)="this.activeItemTheme='theme12'" class="small" active-item-theme="theme12"></a>
                        </div>
                      </li>
                      <li><p class="selector-title">Background Patterns</p></li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a href="javascript:" class="small" (click)="setBackgroundPattern('pattern1')" themebg-pattern="pattern1"></a>
                          <a href="javascript:" class="small" (click)="setBackgroundPattern('pattern2')" themebg-pattern="pattern2"></a>
                          <a href="javascript:" class="small" (click)="setBackgroundPattern('pattern3')" themebg-pattern="pattern3"></a>
                          <a href="javascript:" class="small" (click)="setBackgroundPattern('pattern4')" themebg-pattern="pattern4"></a>
                          <a href="javascript:" class="small" (click)="setBackgroundPattern('pattern5')" themebg-pattern="pattern5"></a>
                          <a href="javascript:" class="small" (click)="setBackgroundPattern('pattern6')" themebg-pattern="pattern6"></a>
                        </div>
                      </li>
                      <li><p class="selector-title">Header Brand Color</p></li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a href="javascript:" (click)="this.logoTheme='theme1'" logo-theme="theme1">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.logoTheme='theme2'" logo-theme="theme2">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.logoTheme='theme3'" logo-theme="theme3">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.logoTheme='theme4'" logo-theme="theme4">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.logoTheme='theme5'" logo-theme="theme5">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                        </div>
                      </li>
                      <li><p class="selector-title">Header Theme</p></li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a href="javascript:" (click)="this.headerTheme='theme1';this.logoTheme='theme1'" header-theme="theme1">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.headerTheme='theme2';this.logoTheme='theme2'" header-theme="theme2">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.headerTheme='theme3';this.logoTheme='theme3'" header-theme="theme3">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.headerTheme='theme4';this.logoTheme='theme4'" header-theme="theme4">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.headerTheme='theme5';this.logoTheme='theme5'" header-theme="theme5">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a href="javascript:" (click)="this.headerTheme='theme6';this.logoTheme='theme6'" header-theme="theme6">
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                        </div>
                      </li>

                    </ul>
                  </div>
                </div>
              </div>
              <ul>
                <li>
                  <a href="https://codedthemes.com/item/guru-able-free-admin-template/" target="_blank" class="btn btn-success btn-block m-r-15 m-t-10 m-b-10">Free ! Download Lite Version</a>
                  <a href="http://html.codedthemes.com/guru-able/doc-angular-4" target="_blank" class="btn btn-primary btn-block m-r-15 m-t-5 m-b-10">Online Documentation</a>
                </li>
                <li class="text-center">
                  <span class="text-center f-18 m-t-15 m-b-15 d-block">Thank you for sharing !</span>
                  <a href="https://www.facebook.com/codedthemes" target="_blank" class="btn btn-facebook soc-icon m-b-20"><i class="icofont icofont-social-facebook"></i></a>
                  <a href="https://twitter.com/codedthemes" target="_blank" class="btn btn-twitter soc-icon m-l-20 m-b-20"><i class="icofont icofont-social-twitter"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
